import { action, observable } from 'mobx'

export default class SideConversationsConfigViewModel {
  @observable enabled = false

  @action
  activate(sideConversationsConfig) {
    this.enabled = sideConversationsConfig?.enabled || false
  }

  toJSON() {
    return {
      enabled: this.enabled,
    }
  }
}
